import { Component } from '@angular/core';
import { WebapiService } from '../../../shared/services/webapi.service';

@Component({
  selector: '[app-topmenu]',
  templateUrl: './topmenu.component.html',
  styleUrls: ['./topmenu.component.scss'],
})
export class TopmenuComponent {

  constructor(public webApi: WebapiService) {}
}
